<template>
    <b-container>
        <b-row class="mb-5">
            <b-col cols="12">
                <b-card :header="`${ company_name } - 평가 정보`" header-class="h5" no-body>
                    <template #header>
                        <div class="d-flex align-items-bottom justify-content-between">
                            <h5> {{ `${company_name} - 평가 정보` }} </h5>

                            <template v-if="!!priority">
                                <b-btn size="sm"
                                       :variant="is_report_company_original ? 'dark' : 'primary'"
                                       @click="is_report_company_original = !is_report_company_original">
                                    <span class="mr-1">
                                        {{ is_report_company_original ? '평가대체 기업으로 전환' : '원래 기업으로 전환' }}
                                    </span>
                                    <b-icon-arrow-clockwise/>
                                </b-btn>
                            </template>
                        </div>
                    </template>
                    <b-table-simple bordered class="bg-white mb-0">
                        <b-thead>
                            <b-tr>
                                <b-th>프로젝트 코드</b-th>
                                <b-th>캠페인</b-th>
                                <b-th>회사명</b-th>
                                <b-th>평가 관련</b-th>
                                <b-th>평가신청자</b-th>
                                <b-th>평가유형</b-th>
                                <!-- <b-th>status_code</b-th> -->
                                <b-th>audit_status</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr>
                                <b-td>{{ this.report_company_info.project_code }}</b-td>
                                <b-td>
                                    {{ this.report_company_info.campaign_name }}
                                    <b-badge>{{ this.report_company_info.campaign_id }}</b-badge>
                                </b-td>
                                <b-td>
                                    {{ this.report_company_info.company_name }}
                                    <b-badge>{{ this.report_company_info.company_id }}</b-badge>
                                </b-td>
                                <b-td>
                                    {{ statsLabel_eng[this.report_company_info.status_code] }}
                                </b-td>
                                <b-td>{{ this.report_company_info.requested_e_mail }}</b-td>
                                <b-td>{{ this.report_company_info.service_type }}</b-td>
                                <b-td>{{ this.report_company_info.audit_status }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <div class="d-flex align-items-center justify-content-between mb-3">
                    <h4 class="mb-0">결과보고서 버전 및 배포 관리</h4>
                    <b-btn variant="info" size="sm" :disabled="tab_disabled" @click="getReportHistory(true)">
                        삭제내역 조회
                    </b-btn>
                </div>
                <b-card no-body>
                    <b-tabs v-model="activatingContent" active-nav-item-class="fw-500" card
                            @activate-tab="preventMoveTab">
                        <b-tab title-link-class="gray-550" active no-body>
                            <!-- :disabled="tab_disabled" -->
                            <template #title>
                                <strong>결과보고서 버전 관리</strong>
                                <b-spinner v-show="is_loading_histroy" type="grow" class="ml-1 mb-1" small/>
                            </template>
                            <b-table :fields="reportHistoryField"
                                     :items="reportHistory"
                                     :busy="is_loading_histroy"
                                     class="mb-0"
                                     show-empty
                                     show-busy
                                     empty-text="배포한 이력이 없습니다."
                                     hover
                                     responsive
                            >

                                <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                        <strong class="mr-2">Loading...</strong>
                                        <b-spinner class="align-middle"></b-spinner>
                                    </div>
                                </template>

                                <template #empty="scope">
                                    <div class="text-center bgray-200 py-4">
                                        <h4 class="mb-0">{{ scope.emptyText }}</h4>
                                    </div>
                                </template>

                                <template #cell(report_name)="data">
                                    <div style="word-break: break-all">
                                        {{ data.value }}
                                    </div>
                                </template>

                                <template #cell(time_stamp)="data">
                                    <div>
                                        <b-badge class="fw-500 mr-1">생성</b-badge>
                                        {{ formatDate(data.value) }}
                                    </div>
                                    <div v-if="!!data.item.deleted_at">
                                        <b-badge variant="danger" class="fw-500 mr-1">삭제</b-badge>
                                        {{ formatDate(data.item.deleted_at) }}
                                    </div>
                                    <div v-else-if="data.item.sent_at">
                                        <b-badge variant="primary" class="fw-500 mr-1">배포</b-badge>
                                        {{ formatDate(data.item.sent_at) }}
                                    </div>
                                </template>

                                <template #cell(confirmed)="data">
                                    <b-badge :variant="!data.value ? 'warning' : 'primary'"
                                             class="fw-500 f-85 px-3 py-2"
                                             pill
                                    >
                                        {{ data.value ? '확정' : '미확정' }}
                                    </b-badge>
                                </template>

                                <template #cell(mode)="data">
                                    {{ assessment_type_obs[data.value] }}
                                </template>

                                <template #cell(is_send_mail)="data">
                                    <b-badge
                                        :variant="data.value ? 'primary' : data.value === false ? 'danger' : 'secondary'"
                                        class="fw-500 f-85 px-3 py-2"
                                        pill
                                    >
                                        {{ data.value ? '배포 완료' : data.value === false ? "배포 실패" : "미배포" }}
                                    </b-badge>
                                </template>

                                <template #cell(deleted_at)="data">
                                    <template v-if="data.value || data.item.reverted_at">
                                        <ul>
                                            <li v-if="data.value">
                                                삭제일시: {{ data.value }}
                                            </li>
                                            <li v-if="data.item.reverted_at">
                                                삭제취소 일시: {{ data.item.reverted_at }}
                                            </li>
                                        </ul>
                                    </template>
                                    <template v-else>
                                        -
                                    </template>
                                </template>

                                <template #cell(action)="data">
                                    <!-- 기존 b-dropdown 제거, 포털 기반 커스텀 드롭다운 구현 -->
                                    <div class="action-dropdown-wrapper">
                                        <b-button
                                            :id="`report-action-btn-${data.index}`"
                                            ref="actionBtn"
                                            size="sm"
                                            variant="outline-secondary"
                                            class="d-inline-flex align-items-center"
                                            :disabled="tab_disabled"
                                            @click="toggleActionMenu(data)"
                                        >
                                            <span v-if="is_confirming_report_target !== null && is_confirming_report_target === data.index">
                                                {{ data.item.confirmed ? '확정 취소중' : '확정중' }}
                                            </span>
                                            <span v-else-if="is_releasing_report_target !== null && is_releasing_report_target === data.index"> 배포중 </span>
                                            <span v-else-if="is_cancelling_report_target !== null && is_cancelling_report_target === data.index"> 삭제중 </span>
                                            <span v-else-if="is_reverting_report_target !== null && is_reverting_report_target === data.index"> 복원중 </span>
                                            <span v-else>결과보고서 관리</span>
                                            <b-spinner v-show="
                                                is_confirming_report_target === data.index
                                                || is_releasing_report_target === data.index
                                                || is_cancelling_report_target === data.index
                                                || is_reverting_report_target === data.index
                                                " style="width: 0.9rem;height: 0.9rem;margin-bottom: 0.15rem;margin-left: 0.15rem;"/>
                                            <b-icon-caret-down-fill class="ml-1"/>
                                        </b-button>

                                        <portal v-if="openActionIndex === data.index" to="global-dropdown">
                                            <div ref="actionPortalRoot" class="dropdown-portal" :style="actionPortalStyle">
                                                <div class="dropdown-menu show py-0" :class="{'dropup-menu': actionDropUp}">
                                                    <button type="button" class="dropdown-item border-bottom" :disabled="tab_disabled"
                                                            @click="downloadReport(data.item); closeActionMenu()">
                                                        <BIconDownload scale="0.8" class="mr-1"/> 다운로드
                                                    </button>
                                                    <button type="button" class="dropdown-item border-bottom" :disabled="tab_disabled"
                                                            @click="viewReport(data.item); closeActionMenu()">
                                                        <BIconEye scale="0.8" class="mr-1"/> 미리보기
                                                    </button>

                                                    <template v-if="!data.item.deleted_at">
                                                        <button type="button" class="dropdown-item border-bottom"
                                                                :class="{ 'bgray-100': !!data.item.deleted_at }"
                                                                :disabled="!!data.item.deleted_at"
                                                                @click="confirmReport(data.item.id, data.item.confirmed, data.item.mode, data.index); closeActionMenu()"
                                                        >
                                                            <component :is="data.item.confirmed ? 'BIconArrowClockwise' : 'BIconCheckCircle'" scale="0.8" class="mr-1"/>
                                                            {{ data.item.confirmed ? '확정 취소' : '확정' }}
                                                        </button>

                                                        <button type="button" class="dropdown-item border-bottom"
                                                                :class="{ 'bgray-100': !data.item.confirmed || !!data.item.deleted_at || data.item.is_send_mail || tab_disabled }"
                                                                :disabled="!data.item.confirmed || !!data.item.deleted_at || data.item.is_send_mail || tab_disabled"
                                                                @click="openConfirmReleaseReport(data.item, data.index)"
                                                        >
                                                            <BIconEnvelopeFill scale="0.8" class="mr-1"/>
                                                            {{ data.item.is_send_mail ? '배포완료' : '배포하기' }}
                                                        </button>
                                                    </template>

                                                    <template v-if="!data.item.is_send_mail">
                                                        <template v-if="data.item.time_stamp && !data.item.deleted_at">
                                                            <button type="button" class="dropdown-item"
                                                                    :class="{ 'bgray-100': data.item.is_send_mail }"
                                                                    :disabled="report_company_info.status_code !== 'in_assessment' && (data.item.is_send_mail || tab_disabled)"
                                                                    @click="cancelReleaseReport(data.item, data.index); closeActionMenu()"
                                                            >
                                                                <BIconTrashFill scale="0.8" class="mr-1"/> 삭제하기
                                                            </button>
                                                        </template>
                                                        <template v-else>
                                                            <button type="button" class="dropdown-item"
                                                                    :disabled="report_company_info.status_code !== 'in_assessment' && (data.item.is_send_mail || tab_disabled)"
                                                                    @click="revertDeletedReport(data.item, data.index); closeActionMenu()"
                                                            >
                                                                <BIconArrowClockwise scale="0.8" class="mr-1"/> 복원하기
                                                            </button>
                                                        </template>
                                                    </template>
                                                </div>
                                            </div>
                                        </portal>
                                    </div>
                                </template>
                            </b-table>
                        </b-tab>

                        <b-tab title-link-class="gray-550">
                            <!-- :disabled="tab_disabled" -->
                            <template #title>
                                미리보기 및 배포
                                <b-spinner v-show="is_loading_preview && !is_full_loaded_reportData" type="grow"
                                           class="ml-1 mb-1" small/>
                            </template>
                            <template v-if="!is_loading_preview && is_full_loaded_reportData">
                                <b-card class="mb-3">
                                    <template #header>
                                        <div class="d-flex align-items-center justify-content-between">
                                            <h6 class="mb-0">결과보고서 옵션 및 배포 설정</h6>

                                            <div class="text-right">
                                                <b-btn variant="primary"
                                                       size="sm"
                                                       :disabled="tab_disabled"
                                                       @click="request_report = !request_report"
                                                >
                                                    결과보고서 생성하기

                                                    <b-spinner v-show="is_releasing_report"
                                                               class="ml-1"
                                                               style="width: 1rem;height: 1rem;margin-bottom: 0.15rem;"
                                                    />
                                                </b-btn>
                                            </div>
                                        </div>
                                    </template>
                                    <b-row class="mb-4">
                                        <b-col cols="12">
                                            <b-form-group id="input-group-report-name"
                                                          label="보고서 이름"
                                                          label-for="input-report-name"
                                                          class="mb-0"
                                            >
                                                <div class="d-flex">
                                                    <b-form-input
                                                        id="input-report-name"
                                                        v-model="pdf_filename"
                                                        :disabled="tab_disabled"
                                                        required
                                                    />
                                                    <b-button class="ml-3" style="width: 150px"
                                                              @click="applyReportCustomName"
                                                    >보고서 이름 적용</b-button>
                                                </div>
                                              
                                                
                                            </b-form-group>
                                            
                                        </b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col cols="12" md="6" lg="auto">
                                            <b-form-group id="input-group-report-language"
                                                          label="보고서 언어"
                                                          label-for="input-report-language"
                                                          class="mb-0"
                                            >
                                                <dropdown-language id="input-group-report-language"
                                                                   :lang="report_lang"
                                                                   :disabled="tab_disabled"
                                                                   @updateLang="updateLang"
                                                />
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="2">
                                            <b-form-group id="input-group-report-types"
                                                          label="보고서 유형"
                                                          label-for="input-report-types"
                                                          class="mb-0"
                                            >
                                                <b-form-select
                                                    id="input-report-types"
                                                    v-model="selected_report_mode"
                                                    :options="[
                                                        { text: '통합본', value: 'full' },
                                                        { text: '요약본', value: 'summary' }
                                                    ]"
                                                    :disabled="tab_disabled"
                                                    required
                                                />
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="2">
                                            <b-form-group id="input-group-report-assessment_types"
                                                          label="보고서 평가유형"
                                                          label-for="input-report-assessment_types"
                                                          class="mb-0"
                                            >
                                                <b-form-select id="input-report-assessment_types"
                                                               :key="assessment_type_select_key"
                                                               :value="selected_assessment_type"
                                                               :options="[
                                                        { text: '서면평가', value: 'DOC' },
                                                        { text: '실사평가', value: 'OSIS' },
                                                    ]"
                                                               :disabled="tab_disabled || is_updating_service_type"
                                                               @change="changeAssessmentType"
                                                />
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="2">
                                            <b-form-group id="input-group-report-re_assessment"
                                                          label="재평가 라벨 설정"
                                                          label-for="input-report-re_assessment"
                                                          class="mb-0"
                                            >
                                                <b-form-checkbox id="input-report-re_assessment"
                                                                 v-model="is_set_reassessment_label"
                                                                 :disabled="tab_disabled"
                                                >
                                                    재평가 라벨 추가
                                                </b-form-checkbox>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="3">
                                            <b-form-group id="input-group-report-re_assessment"
                                                          label="실 평가기간 교체"
                                                          label-for="input-report-duration"
                                                          class="mb-0"
                                            >
                                                <b-form-checkbox id="input-report-duration"
                                                                 v-model="is_set_actual_duration"
                                                                 :disabled="tab_disabled"
                                                >
                                                    실제 평가기간으로 교체
                                                </b-form-checkbox>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </b-card>
                                <template v-if="activatingContent === 1">
                                    <b-overlay
                                        :show="is_loading_released || is_releasing_report || is_report_self_update"
                                        rounded
                                        opacity="0.8"
                                        spinner
                                        spinner-variant="primary"
                                    >
                                        <ReportViewerContainer
                                            ref="reportViewer"
                                            :preview="true"
                                            :report_lang="report_lang"
                                            :reportData="reportData"
                                            :pdf_filename="pdf_filename"
                                            :reportMode="selected_report_mode"
                                            :needReport="request_report"
                                            :assessmentType="selected_assessment_type"
                                            :is_reassessment="is_set_reassessment_label"
                                            :set_actual_duration="is_set_actual_duration"
                                            @sendReportBlob="releaseReport"
                                            @self-report-update="(data) => is_report_self_update = data"
                                        />
                                    </b-overlay>
                                </template>
                            </template>
                            <template v-else>
                                {{ $t('불러오는 중')}}....
                            </template>
                        </b-tab>
                    </b-tabs>
                </b-card>
            </b-col>
        </b-row>

        <b-modal id="modal-report-viewer" :title="$t('결과보고서 보기')" size="xxl"
                 hide-footer
                 body-bg-variant=" bgray-200"
                 scrollable
                 @hidden="onHiddenRerportViewer"
        >
            <b-container>
                <b-row :class="[{ 'd-none': reportPDFLoaded }]" align-h="center" align-v="center" class="bg-white">
                    <b-col cols="12">
                        <div class="p-5">
                            <p v-if="$i18n.locale === 'ko'"> 결과보고서 PDF 불러오는 중... </p>
                            <p v-else-if="$i18n.locale === 'en'"> Loading on the Report PDF... </p>
                            <p v-else> 正在載入 PDF 報告... </p>
                            <div class="d-block">
                                <b-progress :value="reportPDFLoadProgress" max="100" show-progress></b-progress>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-row align-h="center" :class="[{ 'd-none': !reportPDFLoaded }]">
                    <b-col cols="12">
                        <b-card body-class="bgray-200 overflow-auto vh-100">
                            <template #header>
                                <div class="d-flex justify-content-between align-items-center">
                                    <h6 class="mb-0">{{$t('결과보고서 뷰어')}}</h6>
                                </div>
                            </template>

                            <b-row class="justify-content-center">
                                <b-col cols="12" xl="10" xxl="9" class="">
                                    <vue-pdf-embed ref="contractor-report-viewer"
                                                   :source="view_target_report"
                                                   :textLayer="true"
                                                   :annotationLayer="true"
                                                   @progress="onProgressReportLoad"
                                                   @loaded="onReportLoaded"
                                    />
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>
        <b-modal id="modal-confirm-release-report"
                 :title="$t('결과보고서 배포 확인')"
                 size="md"
                 hide-footer
                 body-class="p-4">
            <section v-if="reportHistory?.[selected_report_history_data.index]">
                <!-- 메일 전송 옵션 -->
                <b-card class="border-0 bg-light">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center">
                            <b-icon-envelope-fill variant="primary" scale="1.3" class="mr-3"/>
                            <div>
                                <div class="font-weight-bold mb-1">이메일 자동 발송</div>
                                <small class="text-muted">평가 신청자에게 결과보고서를 이메일로 전송합니다</small>
                            </div>
                        </div>
                        <b-form-checkbox 
                            v-model="is_send_release_mail" 
                            size="lg" 
                            name="check-button" 
                            switch
                            :disabled="is_releasing_report"
                        />
                    </div>
                </b-card>
                
                <!-- 배포 대상 정보 -->
                <b-card class="mb-3 border-0 bg-light">
                    <div class="d-flex align-items-start">
                        <div class="flex-grow-1">
                            <div class="mb-1" style="font-size: 1.1em;">배포 대상 보고서</div>
                            <div class="font-weight-bold" style="word-break: break-word;">
                                {{ reportHistory[selected_report_history_data?.index]?.['report_name'] }}
                            </div>
                        </div>
                    </div>
                </b-card>
                
                <!-- 경고 메시지 -->
                <b-alert show variant="warning" class="mb-4">
                    <div class="d-flex align-items-start">
                        <b-icon-exclamation-triangle-fill class="mr-2 mt-1"/>
                        <div>
                            <div class="font-weight-bold mb-2">배포 전 확인사항</div>
                            <ul class="mb-0 pl-3">
                                <li>결과보고서를 배포하시면 <strong>삭제 및 복구가 불가능</strong>합니다.</li>
                                <li>배포 후에는 해당 보고서를 수정할 수 없습니다.</li>
                            </ul>
                        </div>
                    </div>
                </b-alert>
                
                <!-- 확인 질문 -->
                <div class="text-center mb-4">
                    <h5 class="mb-0">정말로 배포하시겠습니까?</h5>
                </div>
            </section>
            
            <!-- 버튼 영역 -->
            <div class="d-flex align-items-center justify-content-center" style="gap: 12px">
                <b-button 
                    variant="primary" 
                    size="lg"
                    class="px-5"
                    :disabled="is_releasing_report"
                    @click="confirmReleaseReport(true)">
                    <b-spinner v-if="is_releasing_report" small class="mr-2"/>
                    <b-icon-send-fill v-else class="mr-2"/>
                    {{ is_releasing_report ? '배포 중...' : '배포하기' }}
                </b-button>
                <b-button 
                    variant="outline-secondary" 
                    size="lg"
                    class="px-5"
                    :disabled="is_releasing_report"
                    @click="confirmReleaseReport(false)">
                    <b-icon-x-circle class="mr-2"/>
                    {{ $t('취소') }}
                </b-button>
            </div>
        </b-modal>
    </b-container>
</template>

<script>
import { getErrorMessage } from '@core/utils/api/errorMessage';
import axios from 'axios';
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';
import ReportTranslationMixin from '@shared_mixins/report/report.translation.mixin.js';
import ReportNamingMixin from '@shared_mixins/report/report.naming.mixin.js';
import initializeDataProgress from '@shared_mixins/contractor-dashboard/initialize-data-progress';
import ReportViewerContainer from '@shared_components/admin/components/report/ReportViewerContainer.vue';
import DropdownLanguage from '@shared_components/utils/dropdown-language.vue';
import {mapActions} from 'vuex';

export default {
    name: 'ManagingResultReportV2',
    mixins: [
        initializeDataProgress,
        ReportTranslationMixin,
        ReportNamingMixin
    ],
    components: {
        ReportViewerContainer,
        DropdownLanguage,
        VuePdfEmbed
    },
    props: {
        project_code: {
            default: null,
            type: [Object, String]
        },
        campaign_id: {
            default: null,
            type: [Object, Number]
        },
        campaign_name: {
            default: null,
            type: [Object, String]
        },
        company_id: {
            default: null,
            type: [Object, Number]
        },
        company_name: {
            default: null,
            type: [Object, String]
        },
        period: {
            default: null,
            type: [Object, String]
        },
        request_id: {
            default: null,
            type: [Object, Number]
        },
        requested_e_mail: {
            default: null,
            type: [Object, String]
        },
        service_type: {
            default: null,
            type: [Object, String]
        },
        status_code: {
            default: null,
            type: [Object, String]
        },
        audit_status: {
            default: null,
            type: [Object, String]
        },
        no_rating: {
            default: null,
            type: [Boolean]
        },
        priority: {
            default: null,
            type: [Object]
        },
    },
    data() {
        return {
            assessment_type_obs: {
                DOC: '서면평가',
                OSIS: '실사평가'
            },

            // 결과보고서 배포 관리
            activatingContent: 0,
            is_loading_histroy: false,
            reportHistory: null,
            reportHistoryField: [
                {
                    key: 'report_name',
                    label: '보고서명',
                    sortable: true,
                    thStyle: {
                        width: '370px',
                    },
                    tdClass: ['align-middle']
                },
                {
                    key: 'mode',
                    label: '보고서 유형',
                    sortable: true,
                    tdClass: ['align-middle', 'text-center']
                },
                {
                    key: 'time_stamp',
                    label: '생성 및 배포 일시',
                    sortable: true,
                    thClass: 'text-center',
                    thStyle: {
                        width: '200px'
                    },
                    tdClass: ['text-center', 'align-middle'],
                    tdStyle: {
                        alignItems: 'center'
                    }
                },
                {
                    key: 'confirmed',
                    label: '확정 여부',
                    sortable: true,
                    thClass: 'text-center',
                    tdClass: ['text-center', 'align-middle'],
                    thStyle: {
                        width: '100px'
                    },
                },
                {
                    key: 'is_send_mail',
                    label: '배포 여부',
                    sortable: true,
                    thClass: 'text-center',
                    tdClass: ['text-center', 'align-middle'],
                    thStyle: {
                        width: '100px'
                    },
                },
                {
                    key: 'action',
                    label: '보고서 관리',
                    sortable: true,
                    thClass: 'text-center',
                    thStyle: {
                        width: '150px'
                    },
                    tdClass: ['text-center', 'align-middle'],
                    tdStyle: {
                        alignItems: 'center'
                    }
                }
            ],

            // 결과보고서 미리보기
            is_loading_preview: false,
            is_report_self_update: false,
            pdf_filename: null,
            selected_report_mode: 'full',
            selected_assessment_type: null,
            assessment_type_select_key: 0,
            is_updating_service_type: false,
            changed_service_types: {},
            is_set_reassessment_label: false,
            is_set_actual_duration: true,
            report_lang: this.$i18n.locale,
            report_mode: null,
            reportData: {
                info: null,
                benchmarks: null,
                parser: null,
                risk: null,
                scoring: null
            },

            // 라이브 미리보기가 아닌 생성된 보고서 미리보기용
            view_target_report: null,
            reportPDFLoaded: false,
            reportPDFLoadProgress: 0,

            // 결과보고서 관리 (확정 및 배포, 삭제)
            request_report: false,
            is_necessary_eng_email: false,
            is_loading_released: false,
            is_confirming_report: false,
            is_releasing_report: false,
            is_cancelling_report: false,
            is_reverting_report: false,
            is_confirming_report_target: null,
            is_releasing_report_target: null,
            is_cancelling_report_target: null,
            is_reverting_report_target: null,
            release_report: {
                name: null,
                file: null
            },
            is_report_company_original: true,
            
            is_send_release_mail: false,
            selected_report_history_data: {
                data: null,
                index: null,
            },

            // 포털 기반 드롭다운 상태
            openActionIndex: null,
            actionPortalRect: { top: 0, left: 0, width: 0, height: 0 },
            actionDropUp: false,
        };
    },
    computed: {
        tab_disabled() {
            return (this.is_loading_histroy || this.is_loading_preview || this.is_loading_released
                || this.is_confirming_report || this.is_releasing_report || this.is_cancelling_report || this.is_reverting_report
                || this.is_report_self_update
            );
        },
        is_full_loaded_reportData() {
            return Object.values(this.reportData).every(_value => _value !== null);
        },
        confirmed_report_by_service_type() {
            return {
                'DOC': this.reportHistory.some(({mode, confirmed}) => mode === 'DOC' && confirmed === true),
                'OSIS': this.reportHistory.some(({mode, confirmed}) => mode === 'OSIS' && confirmed === true)
            };
        },
        report_company_key() {
            return this.is_report_company_original
                ? `${this.project_code}:${this.company_id}`
                : `${this.priority.project_code}:${this.priority.company_id}`;
        },
        report_company_info() {
            return {
                project_code: this.is_report_company_original ? this.project_code : this.priority.project_code,
                campaign_name: this.is_report_company_original ? this.campaign_name : this.priority.campaign_name,
                campaign_id: this.is_report_company_original ? this.campaign_id : this.priority.campaign_id,
                company_name: this.is_report_company_original ? this.company_name : this.priority.company_name,
                company_id: this.is_report_company_original ? this.company_id : this.priority.company_id,
                requested_e_mail: this.is_report_company_original ? this.requested_e_mail : this.priority.requested_e_mail,
                status_code: this.is_report_company_original ? this.status_code : this.priority.status_code,
                service_type: this.changed_service_types[this.report_company_key]
                    || (this.is_report_company_original ? this.service_type : this.priority.service_type),
                audit_status: this.is_report_company_original ? this.audit_status : this.priority.audit_status,
            };
        },
        actionPortalStyle(){
            return {
                position: 'fixed',
                top: (this.actionDropUp ? (this.actionPortalRect.top - 2) : this.actionPortalRect.bottom) + 'px',
                left: this.actionPortalRect.left + 'px',
                minWidth: this.actionPortalRect.width + 'px',
                zIndex: 3000,
            };
        }
    },
    watch: {
        tab_disabled(_report_global_disabled) {
            this.$emit('prevent-close-report-modal', _report_global_disabled);
        },
        async activatingContent(_current_tab) {
            if (_current_tab === 0) {
                this.is_loading_histroy = false;
                await this.getReportHistory();
            } else {
                this.is_loading_histroy = false;
                this.request_report = false;
                this.reportHistory = null;
                this.is_confirming_report_target = null;
                this.is_releasing_report_target = null;
                this.is_cancelling_report_target = null;
                this.is_reverting_report_target = null;
                this.release_report = {name: null, file: null};

                this.is_loading_preview = false;
                this.reportData = {
                    info: null,
                    benchmarks: null,
                    parser: null,
                    risk: null,
                    scoring: null
                };
                await this.previewReport();
            }
        },
        report_lang: {
            handler() {
                this.generatePDFfilename();
            }
        },
        async is_report_company_original() {
            if (this.activatingContent === 0) {
                this.is_loading_histroy = false;
                await this.getReportHistory();
            } else {
                this.is_loading_histroy = false;
                this.request_report = false;
                this.reportHistory = null;
                this.is_confirming_report_target = null;
                this.is_releasing_report_target = null;
                this.is_cancelling_report_target = null;
                this.is_reverting_report_target = null;
                this.release_report = {name: null, file: null};

                this.is_loading_preview = false;
                this.reportData = {
                    info: null,
                    benchmarks: null,
                    parser: null,
                    risk: null,
                    scoring: null
                };
                await this.previewReport();
            }
        }
    },
    async created() {
        await this.getReportHistory();
    },
    mounted() {
    },
    destroyed() {
        this.activatingContent = 0;
        this.reportHistory = null;
        this.pdf_filename = null;
        this.selected_report_mode = 'full';
        this.selected_assessment_type = null;
        this.report_mode = null;
        this.reportData = {info: null, benchmarks: null, parser: null, risk: null, scoring: null};

        if (this.$i18n.locale !== 'ko') {
            this.$i18n.locale = 'ko';
        }
    },
    methods: {
        ...mapActions('evaluations', ['fetchEvCode']),
        // 실사평가는 심화 전용 — 일반 업체면 심화로 바꿀지 묻고, 바꾸면 미리보기를 실사평가로 전환
        async changeAssessmentType(_type) {
            if (_type !== 'OSIS' || this.report_company_info.service_type !== '일반') {
                this.selected_assessment_type = _type;
                return;
            }
            const h = this.$createElement;
            const _ok = await this.$bvModal.msgBoxConfirm(
                h('div', ['실사평가는 ', h('b', '심화'), ' 유형의 평가만 선택 가능합니다.', h('br'), '평가 유형을 ', h('b', '심화'), '로 변경하겠습니까?']),
                { title: '평가유형 변경', okTitle: '예', cancelTitle: '아니오', centered: true }
            );
            // b-form-select 가 내부 값으로 OSIS 를 들고 있어 재마운트로 현재 선택을 다시 그린다
            if (!_ok) {
                this.assessment_type_select_key++;
                return;
            }
            const { project_code, campaign_id, company_id } = this.report_company_info;
            this.is_updating_service_type = true;
            try {
                const _res = await this.$axios.put('/assessments/service_type', {
                    company_id, campaign_id, project_code, service_type: '심화'
                });
                const _warnings = _res.data.warnings;
                if (_warnings && _warnings.length) {
                    alert(_warnings.join('\n'));
                }
                this.$set(this.changed_service_types, this.report_company_key, _res.data.service_type);
                this.$emit('update-release');
                // 템플릿마다 info.service_type 으로 서면/실사를 고르므로 미리보기 데이터를 다시 받아 실사평가로 전환
                this.assessment_type_select_key++;
                await this.previewReport();
            } catch (error) {
                alert(getErrorMessage(error, '죄송합니다. 평가유형 변경도중 장애가 발생했습니다. 개발팀에 문의주세요.'));
                this.assessment_type_select_key++;
            } finally {
                this.is_updating_service_type = false;
            }
        },
        updateLang(_update_land) {
            this.report_lang = _update_land;
        },
        // 서버가 보낸 사유(신규 422 {message} / 기존 500 {msg, error})를 우선 표시, 없으면 일반 문구
        alertReportError(error, _fallback_msg) {
            const _data = error && error.response && error.response.data;
            const _server_msg = getErrorMessage(error, '') || (_data && _data.msg);
            alert(typeof _server_msg === 'string' && _server_msg.trim() ? _server_msg : _fallback_msg);
        },
        async getReportHistory(search_deleted = false) {
            try {
                this.is_loading_histroy = true;

                let _project_code = this.is_report_company_original ? this.project_code : this.priority.project_code;
                let _campaign_id = this.is_report_company_original ? this.campaign_id : this.priority.campaign_id;
                let _company_id = this.is_report_company_original ? this.company_id : this.priority.company_id;
                let _period = this.is_report_company_original ? this.period : this.priority.period;

                const _res_report_history = await this.$axios.get('/report/history', {
                    params: {
                        project_code: _project_code,
                        campaign_id: _campaign_id,
                        company_id: _company_id,
                        period: _period,
                        with_deleted: search_deleted
                    }
                });

                /**
                 * @todo 	HD_OV_RI_25 529
                 * category2 scoring_pd 가 없음.
                 */
                this.reportHistory = _res_report_history.data.result.reduce((_releases, _release) => {
                    _releases.push({
                        ..._release,
                        time_stamp: this.formatDate(_release.time_stamp),
                        deleted_at: this.formatDate(_release.deleted_at),
                        reverted_at: this.formatDate(_release.reverted_at),
                    });
                    return _releases;
                }, []);
            } catch (error) {
                this.alertReportError(error, '죄송합니다. 결과보고서 배포 이력을 불러오는 도중 장애가 발생했습니다. 개발팀에 문의주시기 바랍니다.');
            } finally {
                this.is_loading_histroy = false;
            }
        },
        async previewReport() {
            try {
                this.is_loading_preview = true;

                let _project_code = this.is_report_company_original ? this.project_code : this.priority.project_code;
                let _campaign_id = this.is_report_company_original ? this.campaign_id : this.priority.campaign_id;
                let _company_id = this.is_report_company_original ? this.company_id : this.priority.company_id;

                // await this.translateEvaluationReview(_project_code, _campaign_id, _company_id, true)
                const _res_report_data = await this.$axios('/report/data', {
                    params: {
                        project_code: _project_code,
                        campaign_id: _campaign_id,
                        company_id: _company_id
                    }
                });
                const ev_code = await this.fetchEvCode();
                
                this.reportData ={
                    ..._res_report_data.data,
                    ev_code_list: ev_code
                };
                

                this.selected_assessment_type = this.reportData.info.service_type === '일반' ? 'DOC' : 'OSIS';
                this.generatePDFfilename();
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    alert('점수계산에 필요한 정보가 없습니다. 다시 한번 확인주세요.');
                } else {
                    this.alertReportError(error, '죄송합니다. 결과보고서 미리보기 준비중 장애가 발생했습니다. 개발팀에 문의주시기 바랍니다.');
                }
            } finally {
                this.is_loading_preview = false;
            }
        },
        async openConfirmReleaseReport(item, index){
            this.$bvModal.show('modal-confirm-release-report');
            this.selected_report_history_data.data = item;
            this.selected_report_history_data.index = index;
            this.closeActionMenu();
        },
        async confirmReleaseReport(action){
            if(action){
                await this.submitReleasedReport(this.selected_report_history_data.data, this.selected_report_history_data.index);
            }
            else {
                this.selected_report_history_data = {
                    data: null,
                    index: null,
                };
            }
            this.is_send_release_mail = true;
            this.$bvModal.hide('modal-confirm-release-report');
        },
        async submitReleasedReport(item, _report_index) {
            try {
                this.is_releasing_report = true;
                this.is_releasing_report_target = _report_index;
                await this.$axios.post('/report/submit', {
                    history_id: item.id,
                    campaign_id: item.campaign_id,
                    project_code: item.project_code,
                    period: item.period,
                    company_id: item.company_id,
                    skip_email: !this.is_send_release_mail,
                    // lang : this.$i18n.locale
                });

                this.reportHistory[_report_index].is_send_mail = true;
                
            } catch (error) {
                this.alertReportError(error, '죄송합니다. 결과보고서 배포 중 장애가 발생했습니다. 개발팀에 문의주시기 바랍니다.');
            } finally {
                this.is_releasing_report_target = null;
                this.is_releasing_report = false;
            }
        },
        generatePDFfilename() {
            let _title = this.report_filename;

            if (this.reportData.info.company.company_name) {
                _title += `_${this.reportData.info.company.company_name}`;
            }
            
            this.pdf_filename = _title;
        },
        async releaseReport(reportBlobData) {
            try {
                this.is_releasing_report = true;
                const {campaign, company_id, project_code} = this.reportData.info;
                const pdfFileObj = new File([reportBlobData], `${this.pdf_filename}.pdf`, {type: 'application/pdf'});

                const formData = new FormData();
                formData.append('campaign_id', campaign.id);
                formData.append('company_id', company_id);
                formData.append('project_code', project_code);
                formData.append('report', pdfFileObj);
                formData.append('auto_e_mail', false);
                formData.append('en', this.$i18n.locale !== 'ko');
                formData.append('mode', this.selected_assessment_type);

                await this.$axios.post('/report/release',
                    formData,
                    {headers: {'Content-Type': 'multipart/form-data'}}
                );

                this.$emit('update-release');
                this.$EventBus.$emit('toast-success', '결과보고서 생성 완료', '결과보고서 생성을 완료하였습니다. "결과보고서 버전 관리" 탭에서 확인해주세요.');
            } catch (error) {
                this.alertReportError(error, '죄송합니다. 결과보고서 배포중 장애가 발생했습니다. 개발팀에 문의주시기 바랍니다.');
            } finally {
                this.is_releasing_report = false;
                this.$refs.reportViewer.is_need_report_blob = false;
            }
        },
        async cancelReleaseReport(_release, _release_index) {
            try {
                this.is_cancelling_report_target = _release_index;
                this.is_cancelling_report = true;
                const _is_confirmed_release_delete = confirm(`"${_release.report_name}" 결과보고서를 \n정말로 삭제하시겠습니까?`);
                if (_is_confirmed_release_delete) {
                    const {id, project_code, campaign_id, period, mode} = _release;
                    await this.$axios.delete('/report/history', {
                        params: {id, project_code, campaign_id, period, mode}
                    });

                    this.reportHistory.splice(_release_index, 1);
                    this.$emit('toast-failure', '삭제 완료', '');
                }
            } catch (error) {
                this.alertReportError(error, '죄송합니다. 결과보고서 버전 삭제 중 장애가 발생했습니다. 개발팀에 문의주시기 바랍니다.');
            } finally {
                this.is_cancelling_report_target = null;
                this.is_cancelling_report = false;
            }
        },
        async revertDeletedReport(_deleted, _deleted_index) {
            try {
                this.is_reverting_report_target = _deleted_index;
                this.is_reverting_report = true;
                const {id, project_code, campaign_id, period, mode, report_key} = _deleted;
                const _res_reverted = await this.$axios.post('/report/history/revert', {
                    id, project_code, campaign_id, period, mode, report_key
                });

                this.$set(this.reportHistory, _deleted_index, _res_reverted.data.result);
            } catch (error) {
                this.alertReportError(error, '죄송합니다. 결과보고서 삭제 복구중 장애가 발생했습니다. 개발팀에 문의주시기 바랍니다.');
            } finally {
                this.is_reverting_report_target = null;
                this.is_reverting_report = false;
            }
        },
        async confirmReport(report_id, confirmed, mode, index) {
            try {
                if (mode === 'OSIS' && !this.confirmed_report_by_service_type['DOC']) {
                    alert('실사평가 대상 기업은 먼저 서면평가 결과보고서 생성 및 확정을 해주시기 바랍니다.');
                    return false;
                }

                this.is_confirming_report_target = index;
                this.is_confirming_report = true;
                let _res_is_confirmed = await this.$axios({
                    method: confirmed ? 'DELETE' : 'PUT',
                    url: '/report/confirm',
                    data: {report_id}
                });

                let _confirmed_report_index = this.reportHistory.findIndex(({id}) => id === report_id);
                if (_confirmed_report_index === -1) {
                    throw new Error('Handling Confirmed Report history');
                }

                _res_is_confirmed.data.time_stamp = this.formatDate(_res_is_confirmed.data.time_stamp);
                _res_is_confirmed.data.deleted_at = this.formatDate(_res_is_confirmed.data.deleted_at);
                _res_is_confirmed.data.reverted_at = this.formatDate(_res_is_confirmed.data.reverted_at);
                _res_is_confirmed.data.send_at = this.formatDate(_res_is_confirmed.data.send_at);

                this.$set(this.reportHistory, _confirmed_report_index, {..._res_is_confirmed.data});
            } catch (error) {
                const _default_error_msg = '결과보고서 데이터를 다시 불러오겠습니다.';
                if (error.response && error.response.status === 409) {
                    alert(`확정된 ${mode === 'DOC' ? '서면평가' : '실사평가'} 결과보고서가 있습니다. ${_default_error_msg}`);
                } else {
                    this.alertReportError(error, `죄송합니다. 결과보고서 확정 중 장애가 발생했습니다. ${_default_error_msg}. 개발팀에 문의주시기 바랍니다.`);
                }

                await this.getReportHistory();
            } finally {
                this.is_confirming_report = false;
                this.is_confirming_report_target = null;
            }
        },
        async viewReport(_report) {
            this.view_target_report = `https://${process.env.VUE_APP_S3_BUCKET_NAME}.s3.${process.env.VUE_APP_S3_REGION_NAME}.amazonaws.com/${_report.report_path}`;
            this.$bvModal.show('modal-report-viewer');
        },
        async downloadReport(_report) {
            const _res_report_block = await axios.get(`https://${process.env.VUE_APP_S3_BUCKET_NAME}.s3.${process.env.VUE_APP_S3_REGION_NAME}.amazonaws.com/${_report.report_path}`, {
                responseType: 'blob'
            });

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(new Blob([_res_report_block.data], {type: 'application/pdf'}));
            link.setAttribute('download', _report.report_name);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        preventMoveTab(...args) {
            const bvEvent = args[args.length - 1];
            if (this.tab_disabled) {
                bvEvent.preventDefault();
            }
        },
        onReportLoaded() {
            this.reportPDFLoaded = true;
        },
        onProgressReportLoad(onProgress) {
            this.reportPDFLoadProgress = (onProgress.loaded / onProgress.total) * 100;
        },
        onHiddenRerportViewer() {
            this.view_target_report = null;
            this.reportPDFLoaded = false;
            this.reportPDFLoadProgress = 0;
        },
        applyReportCustomName(){
            this.$refs.reportViewer.$refs.resultReport.previewPDF();
        },
        toggleActionMenu(row){
            if (this.openActionIndex === row.index) { this.closeActionMenu(); return; }
            this.openActionIndex = row.index;
            this.$nextTick(() => { this.updateActionPortalPosition(row); });
        },
        closeActionMenu(){
            this.openActionIndex = null;
            window.removeEventListener('resize', this.updateActionPortalPosition, { passive: true });
            window.removeEventListener('scroll', this.onAnyScrollAction, true);
            document.removeEventListener('click', this.handleClickOutsideAction, true);
        },
        updateActionPortalPosition(row){
            if (this.openActionIndex === null) return;
            const btn = document.getElementById(`report-action-btn-${row.index}`);
            if (!btn) return;
            const rect = btn.getBoundingClientRect();
            // 임시 rect 저장
            this.actionPortalRect = { top: rect.top, left: rect.left, width: rect.width, height: rect.height, bottom: rect.bottom };
            this.$nextTick(() => {
                const menu = this.$refs.actionPortalRoot && this.$refs.actionPortalRoot.querySelector('.dropdown-menu');
                if (menu) {
                    const menuHeight = menu.getBoundingClientRect().height;
                    const willOverflow = rect.bottom + menuHeight > window.innerHeight;
                    this.actionDropUp = willOverflow && (rect.top - menuHeight) >= 0;
                    // 재계산 top
                    if (this.actionDropUp) {
                        this.actionPortalRect = { ...this.actionPortalRect, top: rect.top, bottom: rect.top - menuHeight };
                    }
                }
            });
            // 리스너 등록
            window.addEventListener('resize', this.updateActionPortalHandler(row), { passive: true });
            window.addEventListener('scroll', this.onAnyScrollAction, true);
            document.addEventListener('click', this.handleClickOutsideAction, true);
        },
        updateActionPortalHandler(row){
            return () => { if (this.openActionIndex === row.index) this.updateActionPortalPosition(row); };
        },
        onAnyScrollAction(){ if (this.openActionIndex !== null) { const row = { index: this.openActionIndex }; this.updateActionPortalPosition(row); } },
        handleClickOutsideAction(e){
            if (this.openActionIndex === null) return;
            const btn = document.getElementById(`report-action-btn-${this.openActionIndex}`);
            const portalRoot = this.$refs.actionPortalRoot;
            const insideBtn = btn && btn.contains(e.target);
            const insidePortal = portalRoot && portalRoot.contains(e.target);
            if (!insideBtn && !insidePortal) this.closeActionMenu();
        },
    }
};
</script>

<style lang="scss" scoped>
/* 포털 기반 드롭다운 추가 스타일 */
.action-dropdown-wrapper { position: relative; display: inline-block; }
.dropdown-portal { /* z-index는 style에서 */ }
.dropdown-menu.dropup-menu { transform: translateY(-100%); }
</style>
